<template>
    <span v-if="isMarked" :title="title" class="text-danger">*</span>
</template>

<script>
import { useMarkedProductsStore } from '@services/pinia/MarkedProductsStore';

export default {
    props: {
        prodId: {
            required: true,
        },
    },
    computed: {
        isMarked() {
            return useMarkedProductsStore().isMarked(this.prodId);
        },
        title() {
            return useMarkedProductsStore().title(this.prodId);
        },
    },
    created() {
        useMarkedProductsStore().load();
    },
};
</script>
